<template>
  <div v-if="materiel">
    <div class="tab">
      <ul>
        <li :class="{'is-active': activeTab === 'infoGenerale'}"
          @click="activeTab = 'infoGenerale'">
          {{ $t('materiel.materiel') }}
        </li>
        <li :class="{'is-active': activeTab === 'technique'}" @click="activeTab = 'technique'"
            >
          {{ $t('materiel.infoTechnique') }}
        </li>
        <li :class="{'is-active': activeTab === 'NomenclatureMateriel'}"
            @click="activeTab = 'NomenclatureMateriel'">
          {{ $t('nomenclatureTechnique.title') }}
        </li>
      </ul>
    </div>
    <component :is="activeTab" :materiel="materiel"
      v-if="materiel" @hasNewLogo="$emit('hasNewLogo', $event)"></component>
  </div>
</template>

<script>
import infoGenerale from '@/components/gabed/materiel/m_infoGenerale';
import technique from '@/components/gabed/materiel/m_technique';
import NomenclatureMateriel from '@/components/gabed/materiel/nomenclatureMateriel';

export default {
  name: 'm_materiel',
  props: {
    materiel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeTab: 'infoGenerale',
    };
  },
  components: {
    infoGenerale,
    technique,
    NomenclatureMateriel,
  },
};
</script>

<style scoped>

</style>
